<ion-list class="legal-list-container legal-list">
  <free-bets-empty *ngIf="showEmptyState()" [isMobile]="isMobile()" [isFbOnline]="isFbOnline()"/>

  <free-bets-total *ngIf="hasFB()" [aPendingFBLength]="aPendingFB()?.length" [activeFBLength]="activeFB()?.length"/>

  <!-- Begin Freebets pendientes-->
  <ion-list-header class="freebet-list-header" *ngIf="hasAPendingFB()">
    <ion-item>
      <h1>
        {{'fbpen' | translate}}
        <!--FREEBET PENDIENTES-->
      </h1>
    </ion-item>
  </ion-list-header>
  <div *ngIf="hasAPendingFB()" class="free-bets-pending">
    <div *ngFor="let itemFb of aPendingFB(); let i = index">
      <!--HACER UNA DIRECTIVA/COMPONENTE PARA PASARLE COMO PARAMETRO LA FREEBET ENTERA Y QUE ESA DIRECTIVA PONGA EL C?DIGO HTML CORRESPONDIENTE AL TIPO DE FREEBET-->
      <!--<span [hidden]="i>indexSeeMorePend">freebet {{i.toString()}} de tipo {{itemFb.Type}}</span>-->
      <tipo-free-bet *ngIf="i<=indexSeeMorePend" [freeBet]="itemFb" [Index]="i.toString()"> </tipo-free-bet>
    </div>
    <button
      ion-button
      (click)="showMoreFreeBet();"
      *ngIf="aPendingFB()?.length > indexSeeMorePend + 1"
      class="more"
    >
      + {{'seeMore' | translate}}
      <!--Ver m?s-->
    </button>
  </div>
  <!-- End Freebets pendientes-->

  <!-- Begin Freebets disponibles -->
  <ion-list-header class="freebet-list-header" *ngIf="hasActiveFB()">
    <ion-item>
      <h1>
        {{'fbdis' | translate}}
        <!--FREEBET DISPONIBLES-->
      </h1>
    </ion-item>
  </ion-list-header>
  <div class="free-bets-avalaible" *ngIf="hasActiveFB()" >
      <free-bets-available [activeFB]="activeFB()" [licenseType]="licenseType()"/>
  </div>
  <!-- End Freebets disponibles -->

    <free-bets-instructions [licenseType]="licenseType()" [hasFB]="hasFB()" [isFbOnline]="isFbOnline()"/>
</ion-list>